module.exports = __webpack_public_path__ + "static/media/signage-indoor-img72.72cfe509.jpg";